var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsMap703(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GPS Map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 43.7L2 40.6V2l20 7.4L42 2l20 7.4V44l-18.8-6.7M42 30.8V2M22 40.2V9.4",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    "data-name": "layer2",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 47.3L32 59l16-31-33.5 15.7 14.2 3.6z",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    "data-name": "layer1",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsMap703);
export default __webpack_public_path__ + "static/media/gps-map-703.7a1cc9c06deb334cb34e3e68bde4e59f.svg";
export { ForwardRef as ReactComponent };